module.exports = __webpack_public_path__ + "img/layout-7_2.58a36aca.png";